import React from "react";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import Footer from "../Footer";
import { useParams } from "react-router-dom";
import { Outlet } from "react-router";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import HelpAndSupport from "./HelpAndSupport";

const Main = () => {
  const urlparam = useParams();
  console.log(
    urlparam.page,
    "pagea page page page ********************************************"
  );
  return (
    <Box className="settings-main">
      <Box className="main-wrapper">
        {/* <h1>main</h1> */}
        {urlparam.page == "edit-profile" ? <EditProfile /> : ""}
        {urlparam.page == "change-password" ? <ChangePassword /> : ""}
        {urlparam.page == "help-and-support" ? <HelpAndSupport /> : ""}
      </Box>
      {/* <Footer /> */}
    </Box>
  );
};

export default Main;
